import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EMPTY_VALUE } from '@src/core/config';
import { setMapLocation } from '@src/core/controllers';
import { routesConfig } from '@src/core/routes';
import { OrderEntity, OrderMissionEntity } from '@src/features/order/entities';
import { setOrderFormData } from '@src/features/order/pages/orders-page/redux';
import { toRepeatedOrder } from './to-repeated-order';

/** Seeds the mission wizard from a finished delivery and opens it. */
export const useRepeatOrder = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return React.useCallback(
    (source?: OrderMissionEntity | OrderEntity | null) => {
      if (!source) return;

      const repeated = toRepeatedOrder(source);

      dispatch(setOrderFormData(repeated));
      dispatch(
        setMapLocation({
          latitude: Number(repeated.deliveryLocation?.latitude) || 0,
          longitude: Number(repeated.deliveryLocation?.longitude) || 0,
          address: repeated.deliveryLocation?.address || EMPTY_VALUE,
        })
      );
      navigate(routesConfig.createOrder);
    },
    [dispatch, navigate]
  );
};

export default useRepeatOrder;
